



























import { LoginAsCustomer } from '@/modules/auth/interfaces/loginAsCustomer';
import { ElForm } from 'element-ui/types/form';
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import AppMessage from 'modules/core/models/appMessage';

@Component({
  components: {
  },
})
export default class SearchCotacts extends Vue {
    public form: LoginAsCustomer = {
        email: '',
    };
    public validationRules!: any;
    public loading: boolean = false;

    @Action('auth/loginAsCustomer')
    private loginAsCustomer!: (request: LoginAsCustomer) => Promise<boolean | undefined>;

    constructor() {
        super();
    }

    public created() {
        this.validationRules = {
        email: [
            { type: 'email', required: true, message: this.$t('forms.invalidEmail'), trigger: 'blur' },
        ],
        };
    }

    public onSubmit() {
        try {
            this.loading = true;

            (this.$refs.selectAccountForm as ElForm).validate(async (valid: boolean) => {
                if (valid) {
                    try {
                        const success = await this.loginAsCustomer(this.form);
                        if (success) {
                            AppMessage.show(
                                this.$t('selectAccount.success'),
                                'success',
                            );
                            this.$router.push('/');
                        } else {
                            AppMessage.show(
                                this.$t('selectAccount.failure'),
                                'error',
                            );
                            this.loading = false;
                        }
                    } catch (error) {
                        console.warn('error', error);
                        AppMessage.show(
                        this.$t('selectAccount.failure'),
                        'error',
                        );
                        this.loading = false;
                    }
                } else {
                    this.loading = false;
                    return false;
                }
            });
        } catch (error) {
            this.loading = false;
            AppMessage.show(
                this.$t('selectAccount.failureMsg', { msg: error }),
                'error',
            );
            console.warn('Error during proccess: ' + error);
        }
    }
}
